import React from 'react';
import PropTypes from 'prop-types';

function DisabledCameraIcon({fill, opacity, ...restProps}) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...restProps}>
            <path
                fill={fill}
                fillRule='evenodd'
                d='M9.98 7.633l.074.077 1.883 2.23h4.605c.578 0 1.048.46 1.064 1.035v1.627l2.212-1.105a.532.532 0 0 1 .77.476v4.667a.532.532 0 0 1-.77.476l-2.212-1.106v.645l1.554 1.84a.855.855 0 0 1-.025 1.127l-.07.069a.835.835 0 0 1-1.112-.019l-.073-.076L8.773 8.81a.855.855 0 0 1 .025-1.128l.07-.068a.835.835 0 0 1 1.112.018zM8.26 10.781l6.664 7.891H9.3c-.578 0-1.049-.46-1.064-1.035V11.005c0-.077.007-.152.023-.224z'
                opacity={opacity}
            />
        </svg>
    );
}

DisabledCameraIcon.propTypes = {
    fill: PropTypes.string,
    opacity: PropTypes.number,
};

DisabledCameraIcon.defaultProps = {
    fill: '#1D1D1B',
    opacity: 0.198,
};

export default DisabledCameraIcon;
